import { render, staticRenderFns } from "./ItemAttribs.vue?vue&type=template&id=0dae4e9d&scoped=true&"
import script from "./ItemAttribs.vue?vue&type=script&lang=js&"
export * from "./ItemAttribs.vue?vue&type=script&lang=js&"
import style0 from "./ItemAttribs.vue?vue&type=style&index=0&id=0dae4e9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae4e9d",
  null
  
)

export default component.exports